const s = 8, a = {
  transition: "all"
}, n = {
  position: "absolute",
  bottom: 2,
  "&:after": {
    content: '""',
    position: "absolute",
    left: 0,
    right: 0,
    top: "100%",
    width: "100%",
    height: "100%",
    background: "transparent"
  }
}, r = (t) => `translate3d(0, ${-10 * t}px, 0) scale(${1 - 0.05 * t})`, e = (t, o) => `translate3d(0, -${o + 8 * t}px, 0) scale(1)`;
export {
  s as TOASTS_STACK_GAP,
  n as piledToast,
  a as toast,
  e as transformHoverToast,
  r as transformToast
};
